<template>
  <div style="margin: 0 20px 20px;">
    <div class="gms-header-banner d-flex align-items-center justify-content-center flex-wrap" style="font-size: 20px; font-weight: bold; position: relative;">
      <div class="gms-header-left">
        <span style="font-size: 24px;">Group Message Sender</span>
      </div>
      Filter By User Type:&nbsp;<b-form-select v-model="user_type" :options="user_type_options" style="font-size: 20px; font-weight: bold; width:230px"/>
      <div class="gms-header-right">
        <b-button size="sm" variant="secondary" class="mr-1" :to="{ name: 'alert_list' }">
          <b>Back To Alerts</b>
        </b-button>
        <b-button size="sm" variant="success" @click="showInfoModal = true" aria-label="more info" title="more info"><i class="fa fa-info-circle"></i></b-button>
      </div>
      <div v-if="test_mode" style="font-weight: bold; color: darkred; font-style: italic; font-size: 18px; width: 100%; text-align: center; margin-top: 10px;">this feature is in test mode and will not send any SMSs or emails - to fully enable, contact support</div>
    </div>

    <b-modal v-model="showInfoModal" title="How Group Message Sender Works" size="lg" ok-only ok-title="Close">
      <div class="text-left" style="white-space: pre-line;">{{groupMessageInfoText}}</div>
    </b-modal>

    <div v-if="user_type.indexOf('_drivers') != -1" class="d-flex align-items-center justify-content-center flex-wrap" style="font-size: 22px; font-weight: bold; margin: 10px 30px 10px 30px">
      Time Available:&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:220px" v-model="driverStartTime" :config="options" :placeholder="driverStartTime"></date-picker>
      &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:220px" v-model="driverEndTime" :config="options" :placeholder="driverEndTime"></date-picker>
      &nbsp;&nbsp;<b-button style="font-size: 20px; font-weight: bold; width:150px" v-on:click.prevent="load_data()">Find Users</b-button>
    </div>
    <div class="row" style="font-size: 22px; font-weight: bold; margin: 10px 30px 10px 30px">
      <div style="padding: 10px;" class="col d-flex align-items-center justify-content-center">Message Format:&nbsp;<b-form-select v-model="message_type" :options="message_type_options" style="font-size: 20px; font-weight: bold; width:120px"/></div>
      <div style="padding: 10px;text-align: left" class="col">
        <PfsRichEditor ref="messagBodyRef" v-model="message_body" style="width:900px" placeholder="Enter a message here."/>
        <PfsFieldHelp
          :fields="pfsGroupFields"
          :editor-ref="$refs.messagBodyRef"
          title="Available Variables"
        />
      </div>
      <div style="padding: 10px; background-color: white" class="d-flex align-items-center justify-content-center">
        <span style="width:150px">
          <b-button v-if="items && items.length > 0" style="font-size: 20px; font-weight: bold; width:150px" v-on:click.prevent="send_sms()">Send {{message_type}}</b-button>
        </span>
      </div>
    </div>
    <div class="row" style="font-size: 22px; font-weight: bold; margin: 10px 30px 10px 30px">
      <div style="padding: 10px;" class="col d-flex align-items-center justify-content-center">Showing: {{items.length}} of {{items_full.length}}</div>
      <div style="padding: 10px;" class="col d-flex align-items-center justify-content-center">
        By Job Title:&nbsp;<b-form-select v-model="job_title_filter" :options="job_title_options" style="font-size: 20px; font-weight: bold; width:255px"/>
      </div>
      <div style="padding: 10px;" class="col d-flex align-items-center justify-content-center">
        By Location:&nbsp;<b-form-select v-model="company_location_filter" :options="location_options" style="font-size: 20px; font-weight: bold; width:290px"/>
      </div>
      <div style="padding: 10px; background-color: white" class="d-flex align-items-center justify-content-center"><span style="width:150px">&nbsp;</span></div>
    </div>

    <div style="margin:20px">
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields"
               :current-page="currentPage"
               :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template slot="first_driver_start_time" slot-scope="row">
            {{row.item.first_driver_start_time | formatDateTimeSmall}}
        </template>

        <template slot="last_driver_end_time" slot-scope="row">
          {{row.item.last_driver_end_time | formatDateTimeSmall}}
        </template>

        <template slot="actions" slot-scope="row">
            <b-button size="sm" @click="reset_user_password(row.item.username)">Reset Password</b-button>&nbsp;
            <b-button size="sm" @click="delete_user(row.item.username)">Delete</b-button>&nbsp;
        </template>
      </b-table>
      <b-row>
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import {get_groupsender_user_list, send_message_to_group} from '../networking/tbn_apis'
import {mapState} from "vuex";
import moment from "moment";
import PfsFieldHelp from './PfsFieldHelp.vue'
import PfsRichEditor from './PfsRichEditor.vue'
import { GROUP_MESSAGE_FIELDS } from '../utils/pfs_fields'

export default {
        name: 'group_message_sender_tbn',
        components: {
          PfsFieldHelp,
          PfsRichEditor,
      },

      data() {
        return {
          test_mode: false,
          driver_available: '',
          msg: 'users',
          showInfoModal: false,
          groupMessageInfoText: `Send an SMS or email to a group of users.

1. Choose a Message Format (SMS or Email). This also decides who's eligible: only users with a phone number show up for SMS, only users with an email address show up for Email.

2. Pick a User Type in the header. The list loads automatically - except for Available/Booked Drivers, where a Time Available range and a "Find Users" button appear so you can pull the list for a specific window.

3. Write your message in the editor. Click "Available Variables" to insert placeholders that get filled in individually when the message is sent.

4. Narrow the list with the Job Title or Location filters if you want - these carry through when you click send.

5. Click "Send SMS"/"Send Email" to message everyone currently matching your filters.

6. The Reset Password and Delete buttons on each row are separate account actions, not part of messaging.

7. If Test Mode is on, no real messages are sent.`,
          message_type: 'SMS',
          message_body: '',
          pfsGroupFields: GROUP_MESSAGE_FIELDS,
          job_title_filter: '',
          job_title_options: [],
          company_location_filter: '',
          location_options: [],
          user_type: 'users',
          tag_filter: '',
          driver_tag_filter: '',
          items: [],
          items_full: [],
          summary: [],
          loading: true,
          totalRows: 1,
          currentPage: 1,
          perPage: 400,
          pages: [],
          user_type_options: [
            { value: '', text: 'All Users' },
            { value: 'users', text: 'Portal Users' },
            { value: 'drivers', text: 'All Drivers' },
            { value: 'available_drivers', text: 'Available Drivers' },
            { value: 'booked_drivers', text: 'Booked Drivers' },
          ],
          message_type_options: [
            { value: 'SMS', text: 'SMS' },
            { value: 'EMAIL', text: 'Email' },
          ],
          fields_all: [],
          fields: [
            { key: 'type', label: 'Type', sortable: true},
            { key: 'email', label: 'Email Address', sortable: true},
            { key: 'name', label: 'Name', sortable: true},
            { key: 'job_title', label: 'Job Title', sortable: true},
            { key: 'company_location', label: 'Location', sortable: true},
            { key: 'phone', label: 'Phone #', sortable: true},
            { key: 'first_driver_start_time', label: 'Driver Start Time', sortable: true},
            { key: 'last_driver_end_time', label: 'Driver End Time', sortable: true},
          ],
          driverStartTime: moment(),
          driverEndTime: moment().add(12, 'hours'),
          options: {
            format: 'MM-DD-YY hh:mm a',
            useCurrent: true,
            minDate: moment().subtract(1,'days'),
            maxDate: moment().add(7, 'days'),
            keepOpen: false,
            showClear: true,
            showClose: true,
          },

        }
      },

      async created() {
        this.fields_all = this.fields
        await this.check_cols()
        await this.load_data()
      },
      methods: {
        async check_cols() {
          this.fields = this.fields_all
          if (this.user_type != 'booked_drivers')
              this.fields = this.fields.filter(item => (item.key != 'first_driver_start_time' && item.key != 'last_driver_end_time'))
        },
        async send_sms() {
          this.$emit('showAlert', "sending messages to group...", 'info')
          const request_body = {
              "user_type": this.user_type,
              "driverStartTime": moment(this.driverStartTime, 'MM-DD-YY hh:mm').format('YYYY-MM-DDTHH:mm:ssZ'),
              "driverEndTime": moment(this.driverEndTime, 'MM-DD-YY hh:mm').format('YYYY-MM-DDTHH:mm:ssZ'),
              "job_title_filter": this.job_title_filter,
              "company_location_filter": this.company_location_filter,
              "message_body": this.message_body,
              "message_type": this.message_type
          }
          await send_message_to_group(this.user.tenant, request_body)
          this.$emit('showAlert', "messages have been sent", 'success', 5000)
        },
        async load_data() {
          this.loading = true
          try {
            const {value: { data = [] } } = await get_groupsender_user_list(this.user.tenant, this.user_type, moment(this.driverStartTime, 'MM-DD-YY hh:mm').format('YYYY-MM-DDTHH:mm:ssZ'), moment(this.driverEndTime, 'MM-DD-YY hh:mm').format('YYYY-MM-DDTHH:mm:ssZ'))
            this.items = data.results
            this.items_full = data.results
            this.job_title_options = data.summary.job_titles
            this.location_options = data.summary.locations
            this.test_mode = data.summary.test_mode
            this.filter_results()
          } catch(e) {
            this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
          }
          this.loading = false
        },
        filter_results() {
          this.items = this.items_full
          if (this.message_type == 'EMAIL')
            this.items = this.items.filter(item => (item.email && item.email.indexOf('@') != -1))
          if (this.message_type == 'SMS')
            this.items = this.items.filter(item => (item.phone))
          if (this.tag_filter != '')
            this.items = this.items.filter(item => (item.tags && item.tags.toLowerCase().indexOf(this.tag_filter.toLowerCase()) != -1))
          if (this.job_title_filter != '')
            this.items = this.items.filter(item => (item.job_title && item.job_title.toLowerCase().indexOf(this.job_title_filter.toLowerCase()) != -1))
          if (this.company_location_filter != '')
            this.items = this.items.filter(item => (item.company_location && item.company_location.toLowerCase().indexOf(this.company_location_filter.toLowerCase()) != -1))
        }
      },
      computed:{
        ...mapState({
          user: state => state.profile.user
        }),
      },
      watch: {
        user: {
          deep: true,
          handler() {
            this.load_data()
          }
        },
        user_type() {
          this.check_cols()

          if (this.user_type.indexOf("_drivers") == -1)
            this.load_data()
          else
            this.items = []
            this.items_full = []
        },
        tag_filter() {
          this.filter_results()
        },
        message_type() {
          this.filter_results()
        },
        company_location_filter() {
          this.filter_results()
        },
        job_title_filter() {
          this.filter_results()
        }
      }
    }
</script>

<style>
  .gms-header-banner {
    width: 100%;
    min-height: 30px;
    margin-bottom: 25px;
    padding: 16px 20px;
    background: linear-gradient(180deg, #f4f8fc 0%, #e8f0f8 100%);
    border: 1px solid #d3e2f0;
    border-radius: 14px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  }

  .gms-header-left {
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
  }

  .gms-header-right {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
  }

  /* below this width the absolutely-positioned title/buttons would overlap the
     centered filter content as it wraps, so stack everything into its own
     full-width line instead */
  @media (max-width: 768px) {
    .gms-header-left,
    .gms-header-right {
      position: static;
      transform: none;
      width: 100%;
      justify-content: center;
      margin: 6px 0;
    }
  }

  .error td { background-color: rgba(255,0,0,0.25)}
  .success td {background-color: hsla(120,100%,75%,0.3)}
  .unprocessed td { background-color: hsla(200,40%,80%,0.3) }
  .cancelled td { background-color: hsla(290,60%,70%,0.3) }

  div.row:nth-child(even) {
    background-color: #f2f2f2;
  }

  tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  .header {
    font-weight: bold;
  }

  div.col {
    border: 1px solid grey;
  }

  .table td {
    padding: .1rem !important;
  }

  .list-text {
    text-align: left;
    margin-top: 7px;
    margin-left: 7px;
  }

  .list-option {
    text-align: left;
    margin: 2px;
  }
</style>

